import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import AkademskoOsoblje from '../views/AkademskoOsoblje'
import Studenti from '../views/Studenti'
import Izdavaci from '../views/Izdavaci'
import Izdanja from '../views/Izdanja'
import ZnanstvenaPodrucja from '../views/ZnanstvenaPodrucja'
import TipoviRada from '../views/TipoviRada'
import BazeIzdanja from '../views/BazeIzdanja'
import axios from 'axios'
import store from '../store'
import Authors from '../views/Authors'
import Rad from '../views/Rad'
import Statistika from "@/views/Statistika.vue";
// import { axios } from 'vue/types/umd'
// import Radovi from '../views/Radovi'


Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        component: Home,
        name: 'default',
        meta: {
            title: 'Home Page - Example App',
            metaTags: [
              {
                name: 'description',
                content: 'The home page of our example app.'
              },
              {
                property: 'og:description',
                content: 'The home page of our example app.'
              }
            ]
          }
    },
    {
        path: '/akademskoOsoblje',
        component: AkademskoOsoblje,
        name: 'AkademskoOsoblje'
    },
    {
        path: '/studenti',
        component: Studenti,
        name: 'Studenti'
    },
    {
        path: '/izdavaci',
        component: Izdavaci,
        name: 'Izdavaci',
    },
    {
        path: '/izdanja',
        component: Izdanja,
        name: 'Izdanja'
    },
    {
        path: '/znanstvena_podrucja',
        component: ZnanstvenaPodrucja,
        name: 'ZnanstvenaPodrucja'
    },
    {
        path: '/tipovi_radova',
        component: TipoviRada,
        name: 'TipoviRada'
    },
    {
        path: '/baze_izdanja',
        component: BazeIzdanja,
        name: 'BazeIzdanja'
    },
    {
        path: '/autori',
        component: Authors,
        name: 'Autori'
    },
    {
        path: '/statistika',
        component: Statistika,
        name: 'Statistika'
    },
    {
        path: '/:rad/pdf',
        component: Rad,
        name: 'Rad'
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: '/',
    routes
})

router.beforeEach(async (to, from, next) => {
    let user = store.state.registar.user
    if (Object.keys(user).length === 0 && user.constructor === Object) {
        user = await axios.get('/sso/user').then(res => {
            return res.data
        })
        store.dispatch('setUser', user)
    }
    // if (to.fullPath != '/') {
    //     if (user.repo_user === 'D') {
    //         next();
    //     } else {
    //         next('/')
           
    //     }
    // } else {
    //     next();
    // }
    next();
});


export default router
